import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { Link, useSearchParams, useParams } from "react-router-dom";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import FooterText from "src/components/footerText";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import { AuthContext } from "../../context/authContext";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import { StatisticsApiResponse } from "../manufacturer/types";
import { objectToQueryString } from "src/helpers";
import CustomComponentCaseVolumeTerritories from "src/components/manufacturer/customComponentCaseVolumeTerritories";
import CustomPracticeListing from "src/components/manufacturer/customPracticeListing";
import CustomProviderPractice from "src/components/manufacturer/customProviderPractice";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import CaseDetail from "src/components/manufacturer/caseDetail";
import TerritoriesFilter from "src/components/manufacturer/territoriesFilter";
import { TerritoriesSearchProps } from "src/components/manufacturer/territoriesFilter/types";
import { MANUFACTURER_DEFAULT_END_DATE, MANUFACTURER_DEFAULT_START_DATE } from "src/constants/manufacturer";


const PatientNavigatorLeads: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, updateSearchParams] = useSearchParams();
  
  const { role, id, } = useParams();
  // console.log("searchParams", { searchParams })
  console.log("role", { role })
  console.log("id", { id })

  // const [queryParams, changeQueryParams] = useState({
  //   start_date:
  //     searchParams.get("start_date") ||
  //     format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
  //   end_date:
  //     searchParams.get("end_date") ||
  //     format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
  //   period: searchParams.get('period') || "",
  //   filter_type: searchParams.get("filter") || "",
  //   // time: searchParams.get("time") || "",
  //   type:  "",
  //   soc_value: searchParams.get("soc_value") || "",
  //   drug_id: searchParams.get("drug_id") || "",
  //   user_id: searchParams.get("user_id") || (userData && userData.ref_type === "rep" ? userData.id.toString() : "") || "",
  //   insurance_name: insuranceName,
  //   case_filter: "",
  //   search_str: "",
  //   role: role || searchParams.get("role") || userData?.ref_type || "",
  //   id: id || "",

  // });
    const [queryParams,changeQueryParams] = useState({
    start_date: searchParams.get('start_date') || MANUFACTURER_DEFAULT_START_DATE,
    end_date: searchParams.get('end_date') || MANUFACTURER_DEFAULT_END_DATE,
    period: searchParams.get('period') || "day",
    filter: searchParams.get('filter') || "",
    time: searchParams.get('time') || "",
    type: "",
    role: role || searchParams.get("role") || userData?.ref_type || "",
    id: Number(id) || Number(searchParams.get('id')) || 0 ,
    case_id: "",
    search_str: searchParams.get("search_str") || "",
    p_id:  Number(id) || Number(searchParams.get('id')) || 0,
  });

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  //useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);
 const updateQueryParamsAndCallAPI = (updatedQueries: TerritoriesSearchProps, isReset: boolean = false): void => {
      if (isReset) {
        changeQueryParams({
          start_date: MANUFACTURER_DEFAULT_START_DATE,
          end_date: MANUFACTURER_DEFAULT_END_DATE,
          period: "",
          filter: "",
          time: "",
          type: "",
          role: "",
          search_str:'',
          case_id:'',
          id: 0,
          p_id: 0,
        });
      } else {
        changeQueryParams(updatedQueries);
      }
  
      setLoader()
      getStatsData({}, {}, updatedQueries);
    };

  return (
    <div className="container-fluid overflow-auto">
      <AuthMaunfacturerSubHeader />
    
       <TerritoriesFilter
        defaultQueryParams={queryParams}
        updateQueryParams={updateQueryParamsAndCallAPI}
      />
      {statisticsData && (
        <CustomComponentCaseVolumeTerritories StatisticsObjectType={statisticsData.data} buttonShows={true} />
      )}
      <div className="row gx-2">
        <div className="col-12 col-lg-4 mb-3 d-flex flex-column flex-fill">
          {statisticsData && statisticsData.data && <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'} />}
        </div>
        <div className="col-12 col-lg-4 mb-3 d-flex flex-column flex-fill">
          {statisticsData && statisticsData.data && <CustomPieChart pieChartObject={statisticsData.data.mos} title={'Cases By Submission Mode'} />}

        </div>
        <div className="col-12 col-lg-4 mb-3 d-flex flex-column flex-fill">
          {statisticsData && statisticsData.data && <CustomPieChart pieChartObject={statisticsData.data.diagnosis} title={'Diagnoses'} />}
        </div>
      </div>
      {statisticsData && (
        <div className="col-12 col-lg-12 mb-3">
          <div className="card">
            <div className="card-header">
              <h1 className="m-0 text-center">Patient Navigators
              </h1>
            </div>
            <div className="card-body p-0" style={{ maxHeight: '500px', overflow: 'auto' }}>
              <table className="table table-responsive table-hover">
                <thead className="table-light sticky-top">
                  <tr className="text-center">
                    <th className="text-white">Name</th>
                    <th className="text-white">Cases</th>
                  </tr>
                </thead>
                <tbody>
                  {statisticsData.data.patient_navigators &&
                    statisticsData.data.patient_navigators.data &&
                    statisticsData.data.patient_navigators.data.length > 0 &&
                    statisticsData.data.patient_navigators.data.map((item, key) => (
                      <tr className="text-center" key={key}>
                        <td>
                          <Link
                            to={{
                              pathname: `/statistics/${item.id}`,
                              search: objectToQueryString(
                                queryParams
                                  ? {
                                    start_date: queryParams.start_date,
                                    end_date: queryParams.end_date,
                                    period: queryParams.period,
                                    // filter_type: queryParams.filter_type,
                                    // case_filter: queryParams.case_filter,
                                    role: "patient_navigator",
                                    id: item.id,
                                    p_id: (queryParams as TerritoriesSearchProps).p_id,

                                  }
                                  : {}
                              ),
                            }}
                            className="p-0 btn btn-link"
                          >
                            {item.name}
                          </Link>
                        </td>
                        <td>{item.cases || ""}</td>
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr className="text-center">
                    <td className="fw-bold">Total</td>
                    <td className="fw-bold">{statisticsData.data.patient_navigators?.total}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      )}
      <div className="row gx-2">
        <div className="col-12 col-md-6 mb-3">
          {statisticsData && statisticsData.data && statisticsData.data.practices &&
            <CustomPracticeListing providerPracticesList={statisticsData.data.practices} title={"Practices"}
              queryParams={queryParams}
            />
          }
        </div>
        <div className="col-12 col-md-6 mb-3">
          {statisticsData && statisticsData.data && statisticsData.data.prescribers &&
            <CustomProviderPractice providerPracticesList={statisticsData.data.prescribers}
              title="Prescribers" queryParam={queryParams}
            />
          }
        </div>
      </div>
      <div className="row">
        {statisticsData && statisticsData.data && statisticsData.data.case_listing &&
          <CaseDetail baseUrl={`/statistics/${id}`} searchParams={queryParams as unknown as StatisticsSearchProps} 
            CaseDetailListType={statisticsData.data.case_listing}
          />
        }
      </div>
      <FooterText footerType="black" />
    </div>
  );
};

export default PatientNavigatorLeads;
